import { PartialRecord } from "@base/util/TypeUtil";
import { AnnotationArticle, ArticleInfo } from "@biz/articles/ArticleInfo";
import { IRopeArticleAnnotation, RopeColor, RopeType } from "@biz/definitions/ArticleDefinitions";
import { RopeDiameter } from "@biz/definitions/SunSailDefinitions";

export class RopeHelper {
  private static ropeArticles: PartialRecord<string, AnnotationArticle<"rope">[] | undefined> = {}

  static getRopeInfo(articleNumber: string | undefined): IRopeArticleAnnotation | undefined {
    if (!articleNumber)
      return undefined;
    const ai = ArticleInfo.getArticleInfo(articleNumber);
    if (ai && ai.rope) return ai.rope;
    return undefined;
  }

  static getRopeTypes(ropeArticles: string[]): PartialRecord<RopeType, RopeDiameter> {
    const ropeTypes: PartialRecord<RopeType, RopeDiameter> = {};
    for (const r of ropeArticles) {
      const ropeInfo = RopeHelper.getRopeInfo(r);
      if (ropeInfo?.ropeType) {
        if (!ropeTypes[ropeInfo.ropeType])
          ropeTypes[ropeInfo.ropeType] = ropeInfo.diameter;
      }
    }
    return ropeTypes;
  }

  static getRopeColors(ropeArticles: string[], key: { ropeType?: RopeType }): PartialRecord<RopeColor, boolean> {
    const ropeColors: PartialRecord<RopeColor, boolean> = {};
    for (const r of ropeArticles) {
      const ropeInfo = RopeHelper.getRopeInfo(r);
      if (key.ropeType && ropeInfo?.ropeType !== key.ropeType)
        continue;
      if (ropeInfo?.colorId) {
        if (!ropeColors[ropeInfo.colorId])
          ropeColors[ropeInfo.colorId] = true;
      }
    }
    return ropeColors;
  }


  static findRope(ropeArticles: string[], keys: { ropeType?: RopeType, colorId?: string }): string | undefined {
    const foundArticle = ropeArticles.find((ra) => {
      const ri = RopeHelper.getRopeInfo(ra);
      return ri && (!keys.ropeType || ri.ropeType === keys.ropeType) && (!keys.colorId || ri.colorId === keys.colorId);
    })
    return foundArticle;
  }

  static getRopeArticles(ropeType: RopeType | RopeType[]): AnnotationArticle<"rope">[] {
    const key = Array.isArray(ropeType) ? ropeType.sort().join("_") : ropeType;

    if (!RopeHelper.ropeArticles[key]) {
      const allRopes = ArticleInfo.calcAnnotationArticles("rope");
      RopeHelper.ropeArticles[key] = Array.isArray(ropeType) ? allRopes.filter((r) => ropeType.includes(r.rope.ropeType)) : allRopes.filter((r) => r.rope.ropeType === ropeType)

    }
    return RopeHelper.ropeArticles[key] || [];
  }

  static getKauscheIdForDiameter(diameter: RopeDiameter): string {
    switch (diameter) {
      case 6.5:
        return "00E13000053";
      case 8:
        return "00E13001415"; // "00E13001353";
      case 10:
        return "00E13000153";
    }
    throw new Error("Kausche diameter not handled: " + diameter);
  }

  static getKauscheForRopeArticle(articleId: string): string {
    const info = ArticleInfo.getArticleInfo(articleId);
    if (!info?.rope?.diameter)
      return "";
    return RopeHelper.getKauscheIdForDiameter(info.rope.diameter)
  }

  static getArticleId(storedArticleId: string | undefined, validItems: string[]): string | undefined {
    const foundArticleId = storedArticleId ? validItems.find((r) => r === storedArticleId) : undefined;
    return foundArticleId || (validItems.length > 0 ? validItems[0] : undefined);
  }

  static getSetRopeByTypeFn(validItems: string[], ropeInfo: IRopeArticleAnnotation | undefined, setArticleFn: (articleId: string | undefined) => void): (ropeType: RopeType) => void {
    return (ropeType) => {
      const foundRope = RopeHelper.findRope(validItems, { ropeType, colorId: ropeInfo!.colorId }) || RopeHelper.findRope(validItems, { ropeType });
      if (foundRope)
        setArticleFn(foundRope)
    }
  }

  static getSetRopeByColorFn(validItems: string[], ropeInfo: IRopeArticleAnnotation | undefined, setArticleFn: (articleId: string | undefined) => void): (colorId: RopeColor) => void {
    return (colorId) => {
      const foundRope = RopeHelper.findRope(validItems, { ropeType: ropeInfo!.ropeType, colorId }) || RopeHelper.findRope(validItems, { colorId })
      if (foundRope)
        setArticleFn(foundRope)
    }
  }
}
